module.exports = __webpack_public_path__ + "static/logo-black-fc5832b42e0b028788d02bb3b7339932.svg";